/* global $:false */

export default class AnimatedFormInput {
  static init () {
    if (this.inputs) {
      for (const input of this.inputs) {
        input.destroy()
      }
    }

    this.inputs = $('.js-animated-form-input').map((idx, elem) => {
      return (new AnimatedFormInput(elem))
    })
  }

  constructor (elem) {
    this.label = $(elem).find('label')
    this.input = $(elem).find('input')

    this.label.on('click', () => {
      this.label.addClass('activated')
      this.input.focus()
    })

    this.input.on('focus', () => {
      this.label.addClass('activated')
    })

    this.input.on('blur', () => {
      if (this.input.val().trim() !== '') { return }

      this.label.removeClass('activated')
    })
  }

  destroy () {
    this.label.off()
    this.input.off()
  }
}
